query GetGiftAccountBalances($dateFrom: ISO8601Date, $dateTo: ISO8601Date) {
  giftAccountBalances(dateFrom: $dateFrom, dateTo: $dateTo) {
    id
    fundAccountId
    fundId
    sageId
    sageGiftAccountId
    fundAccountName
    sageName
    legalEntity
    currency
    fundAccountBalance {
      minorUnit
      currency
    }
    sageBalance {
      minorUnit
      currency
    }
    fundRecordType
    fundOpenedDate
    totalDiscrepancy {
      minorUnit
      currency
    }
  }
}
